var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable, inject } from '@serviceos-rn/core';
import { ICoordinatorType } from '../../Interfaces/ICoordinator';
import { ITipRepositoryType } from '../../UseCases/Tip/ITipRepository';
import { ITipPayloadRepositoryType } from '../../UseCases/Tip/ITipPayloadRepository';
import { ITipEventsRepositoryType } from '../../UseCases/Tip/ITipEventsRepository';
let CoordinatorService = class CoordinatorService {
    constructor(coordinator, repository, payloadRepository, eventsRpository) {
        this.coordinator = coordinator;
        this.repository = repository;
        this.payloadRepository = payloadRepository;
        this.eventsRpository = eventsRpository;
        this.isInitialized = false;
    }
    showToTip() {
        return this.coordinator.showToTip();
    }
    getIsInitialized() {
        return this.isInitialized;
    }
    init() {
        const mode = this.payloadRepository.getMode().value;
        return this.getTip()
            .then(value => {
            if (!Array.isArray(value.choice_items) || value.choice_items.length <= 0) {
                this.repository.logExceptionMissingTipOptions(value);
                return Promise.reject(new Error(('No available tip options')));
            }
            return value;
        })
            .then(value => {
            var _a;
            this.isInitialized = true;
            return ((_a = value.customize) === null || _a === void 0 ? void 0 : _a.tipped)
                ? this.navigateToStatus()
                : this.navigateToTip(mode);
        })
            .catch(error => {
            this.isInitialized = false;
            this.repository.setErrorTip(error.message);
            return this.navigateToStatus();
        });
    }
    getTip() {
        const tip = this.payloadRepository.getTip().value;
        const bookingId = this.payloadRepository.getBookingID().value;
        if (bookingId) {
            return this.repository.getTip(bookingId, true)
                .then(value => {
                this.eventsRpository.sendModuleLoaded();
                return value.value;
            });
        }
        if (!tip) {
            this.eventsRpository.sendModuleLoaded();
            return Promise.reject(new Error('Missing tip params!'));
        }
        return this.repository.setTip(tip)
            .then(value => {
            this.eventsRpository.sendModuleLoaded();
            return value.value;
        });
    }
    navigateToTip(mode = 'normal') {
        return this.coordinator.navigateToTip(mode);
    }
    navigateToStatus() {
        return this.coordinator.navigateToStatus();
    }
    dismiss() {
        return this.coordinator.dismiss();
    }
};
CoordinatorService = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(ICoordinatorType)),
    __param(1, inject(ITipRepositoryType)),
    __param(2, inject(ITipPayloadRepositoryType)),
    __param(3, inject(ITipEventsRepositoryType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], CoordinatorService);
export { CoordinatorService };
